













import { Component, Prop, Vue } from 'vue-property-decorator'
import { DefaultServerResponse } from '@/components/ui/TechTaskCard.vue'
import { FacebookPostRow } from './facebook-post-row'
import request from '@/helpers/requests'


interface AdditionalData {
    qualifyingPost: null;
    hasQualifyingPost: boolean;
}


interface ResponseData extends DefaultServerResponse {
    data: AdditionalData;
}


@Component
export default class AdditionalDataSection extends Vue {
    @Prop() item !: FacebookPostRow
    additionalDetails: null|AdditionalData = null

    async mounted() {
        await this.fetchAccountDetails()
    }

    async fetchAccountDetails() {
        this.additionalDetails = (await request.post('/support/load-facebook-post-details', {
            pulsemAccountId: this.item.pulsemAccountId
        }) as ResponseData).data
    }

    get autoPostEnabled() {
        const autoPostEnabled = this.item.facebookPostSettings?.isAutoPost
        if (autoPostEnabled === undefined) {
            return 'enabled'
        } else {
            return autoPostEnabled ? 'enabled' : 'disabled'
        }
    }

    get postFrequency() {
        const autoPostEnabled = this.item.facebookPostSettings?.postFrequency
        if (autoPostEnabled === undefined) {
            return 'DEFAULT'
        } else {
            return autoPostEnabled
        }
    }
}
